module.exports = __webpack_public_path__ + "static/media/women.1e9cc0f5.jpg";